import { useNavigate } from 'react-router-dom';
import { PortfolioTypeBadge } from '../shared/PortfolioTypeBadge';
import { formatCurrency } from '../../utils/formatting';
import { PersonaBadge } from './PersonaBadge';

/**
 * Workspace title bar — portfolio name + type badge + account value + persona badge.
 * Per wireframe Direction B: back link on left, persona badge with edit on right.
 */
export function WsTitle({ portfolio, agent, onEditPersona }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between px-2 sm:px-4 pt-3 pb-2">
      <div className="flex flex-col gap-1 min-w-0">
        <button
          onClick={() => navigate('/dashboard')}
          className="text-xs text-slate-400 hover:text-slate-200 text-left w-fit"
        >
          ← dashboard
        </button>
        <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
          <h1 className="text-xl sm:text-2xl font-bold text-white truncate">
            {portfolio?.portfolio_name}
          </h1>
          <PortfolioTypeBadge
            portfolioType={portfolio?.portfolio_type}
            isTestnet={portfolio?.is_testnet}
            size="sm"
          />
          <span className="text-xs text-slate-400 font-mono hidden sm:inline">
            {formatCurrency(portfolio?.total_value_usd || 0)}
          </span>
        </div>
      </div>
      {agent && (
        <div className="hidden sm:block flex-shrink-0">
          <PersonaBadge
            name={agent.name}
            avatarSeed={agent.avatar_seed}
            onEdit={onEditPersona}
          />
        </div>
      )}
    </div>
  );
}
